<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Večnamenski izdelki CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655">
     Večnamenski izdelki CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sl" title="Varnostne informacije">
     Varnostne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Oznake">
      Oznake
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="Izjave o izdelku">
      Izjave o izdelku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sl" title="Seznanitev s tiskalnikom">
     Seznanitev s tiskalnikom
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sl" title="Iskanje informacij o tiskalniku">
      Iskanje informacij o tiskalniku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_sl" title="Iskanje serijske &scaron;tevilke tiskalnika">
      Iskanje serijske &scaron;tevilke tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sl" title="Konfiguracije tiskalnika">
      Konfiguracije tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sl" title="Uporaba nadzorne plo&scaron;če">
      Uporaba nadzorne plo&scaron;če
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sl" title="Ikone na začetnem zaslonu">
      Ikone na začetnem zaslonu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_sl" title="Barve indikatorske lučke">
      Barve indikatorske lučke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_sl" title="Uporaba samodejnega podajalnika dokumentov in stekla optičnega bralnika">
      Uporaba samodejnega podajalnika dokumentov in stekla optičnega bralnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sl" title="Iskanje varnostne reže">
      Iskanje varnostne reže
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="Izbiranje papirja">
      Izbiranje papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10635" title="Dodatne funkcije tiskalnika in podpora">
      Dodatne funkcije tiskalnika in podpora
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sl" title="Nastavitev, namestitev in konfiguracija">
     Nastavitev, namestitev in konfiguracija
    </a>
   </p>
   <div id="divd0e10762">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_sl" title="Izbiranje mesta za tiskalnik">
      Izbiranje mesta za tiskalnik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_sl" title="Vrata tiskalnika">
      Vrata tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10961" title="Konfiguriranje aplikacij in re&scaron;itev">
      Konfiguriranje aplikacij in re&scaron;itev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11138" title="Nastavitev in uporaba pripomočkov za osebe s posebnimi potrebami">
      Nastavitev in uporaba pripomočkov za osebe s posebnimi potrebami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11443" title="Nastavitev tiskalnika za faksiranje">
      Nastavitev tiskalnika za faksiranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_sl" title="Nalaganje papirja in posebnih tiskalnih medijev">
      Nalaganje papirja in posebnih tiskalnih medijev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12239" title="Name&scaron;čanje in posodabljanje programske opreme, gonilnikov in vdelane programske opreme">
      Name&scaron;čanje in posodabljanje programske opreme, gonilnikov in vdelane programske opreme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12565" title="Name&scaron;čanje možnosti strojne opreme">
      Name&scaron;čanje možnosti strojne opreme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14096" title="Omrežje">
      Omrežje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sl" title="Za&scaron;čita tiskalnika">
     Za&scaron;čita tiskalnika
    </a>
   </p>
   <div id="divd0e14448">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sl" title="Brisanje pomnilnika tiskalnika">
      Brisanje pomnilnika tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_sl" title="Brisanje shranjevalnega pogona tiskalnika">
      Brisanje shranjevalnega pogona tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sl" title="Obnovitev privzetih tovarni&scaron;kih nastavitev">
      Obnovitev privzetih tovarni&scaron;kih nastavitev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_sl" title="Izjava o obstojnosti">
      Izjava o obstojnosti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sl" title="Tiskanje">
     Tiskanje
    </a>
   </p>
   <div id="divd0e14640">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_sl" title="Tiskanje iz računalnika">
      Tiskanje iz računalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691" title="Tiskanje iz mobilne naprave">
      Tiskanje iz mobilne naprave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sl" title="Tiskanje z bliskovnega pogona">
      Tiskanje z bliskovnega pogona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sl" title="Konfiguracija zaupnih opravil">
      Konfiguracija zaupnih opravil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sl" title="Tiskanje zaupnih in drugih zadržanih opravil">
      Tiskanje zaupnih in drugih zadržanih opravil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_sl" title="Tiskanje seznama vzorcev pisav">
      Tiskanje seznama vzorcev pisav
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_sl" title="Tiskanje seznama imenikov">
      Tiskanje seznama imenikov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_sl" title="Postavitev ločilnih listov v tiskalnih opravilih">
      Postavitev ločilnih listov v tiskalnih opravilih
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sl" title="Preklic tiskalnega opravila">
      Preklic tiskalnega opravila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sl" title="Nastavitev temnosti barvila">
      Nastavitev temnosti barvila
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_sl" title="Kopiranje">
     Kopiranje
    </a>
   </p>
   <div id="divd0e15186">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_sl" title="Kopiranje">
      Kopiranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_sl" title="Kopiranje fotografij">
      Kopiranje fotografij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_sl" title="Kopiranje na pisemski papir z glavo">
      Kopiranje na pisemski papir z glavo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_sl" title="Kopiranje na obe strani papirja">
      Kopiranje na obe strani papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_sl" title="Zmanj&scaron;anje ali povečanje kopij">
      Zmanj&scaron;anje ali povečanje kopij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_sl" title="Zbiranje kopij">
      Zbiranje kopij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_sl" title="Postavitev ločevalnih listov med kopije">
      Postavitev ločevalnih listov med kopije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_sl" title="Kopiranje več strani na en list">
      Kopiranje več strani na en list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_sl" title="Kopiranje kartic">
      Kopiranje kartic
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_sl" title="Ustvarjanje bližnjice za kopiranje">
      Ustvarjanje bližnjice za kopiranje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_sl" title="E-po&scaron;ta">
     E-po&scaron;ta
    </a>
   </p>
   <div id="divd0e15459">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_sl" title="Konfiguriranje nastavitev za SMTP">
      Konfiguriranje nastavitev za SMTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_sl" title="Po&scaron;iljanje e-po&scaron;te">
      Po&scaron;iljanje e-po&scaron;te
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_sl" title="Ustvarjanje bližnjice za e-po&scaron;to">
      Ustvarjanje bližnjice za e-po&scaron;to
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_sl" title="Faksiranje">
     Faksiranje
    </a>
   </p>
   <div id="divd0e16908">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_sl" title="Po&scaron;iljanje faksa">
      Po&scaron;iljanje faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_sl" title="Načrtovanje faksa">
      Načrtovanje faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_sl" title="Ustvarjanje bližnjice do cilja faksa">
      Ustvarjanje bližnjice do cilja faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_sl" title="Spreminjanje ločljivosti faksa">
      Spreminjanje ločljivosti faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_sl" title="Prilagajanje temnosti faksa">
      Prilagajanje temnosti faksa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_sl" title="Tiskanje dnevnika faksiranja">
      Tiskanje dnevnika faksiranja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_sl" title="Blokiranje neželenih faksov">
      Blokiranje neželenih faksov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_sl" title="Zadrževanje faksov">
      Zadrževanje faksov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_sl" title="Posredovanje faksa">
      Posredovanje faksa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_sl" title="Optično branje">
     Optično branje
    </a>
   </p>
   <div id="divd0e17204">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_sl" title="Optično branje v računalnik">
      Optično branje v računalnik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_sl" title="Optično branje v strežnik FTP">
      Optično branje v strežnik FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_sl" title="Ustvarjanje bližnjice do strežnika FTP">
      Ustvarjanje bližnjice do strežnika FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_sl" title="Optično branje v omrežno mapo">
      Optično branje v omrežno mapo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_sl" title="Konfiguriranje cilja v omrežni mapi">
      Konfiguriranje cilja v omrežni mapi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_sl" title="Ustvarjanje bližnjice omrežne mape">
      Ustvarjanje bližnjice omrežne mape
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_sl" title="Optično branje na bliskovni pogon">
      Optično branje na bliskovni pogon
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_sl" title="Meniji tiskalnika">
     Meniji tiskalnika
    </a>
   </p>
   <div id="divd0e17493">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_sl" title="Zemljevid menijev">
      Zemljevid menijev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17807" title="Naprava">
      Naprava
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20041" title="Tiskanje">
      Tiskanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21323" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21655" title="Kopiranje">
      Kopiranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22214" title="Faksiranje">
      Faksiranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24081" title="E-po&scaron;ta">
      E-po&scaron;ta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25178" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25884" title="Pogon USB">
      Pogon USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26730" title="Omrežje/vrata">
      Omrežje/vrata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28881" title="Varnost">
      Varnost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29978" title="Storitve v oblaku">
      Storitve v oblaku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30035" title="Poročila">
      Poročila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_sl" title="Odpravljanje težav">
      <strong>
       Odpravljanje težav
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_sl" title="Spajanje obrazcev">
      <strong>
       Spajanje obrazcev
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sl" title="Kako natisnete Stran z menijskimi nastavitvami">
      Kako natisnete
      <strong>
       Stran z menijskimi nastavitvami
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_sl" title="Možnosti tiskalnika za zaključevanje">
     Možnosti tiskalnika za zaključevanje
    </a>
   </p>
   <div id="divd0e30518">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_sl" title="Uporaba enote za končno obdelavo s spenjalnikom">
      Uporaba enote za končno obdelavo s spenjalnikom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_sl" title="Uporaba enote za končno obdelavo s spenjalnikom in luknjalnikom">
      Uporaba enote za končno obdelavo s spenjalnikom in luknjalnikom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_sl" title="Uporaba odmičnega zlagalnika">
      Uporaba odmičnega zlagalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_sl" title="Uporaba enote za končno obdelavo knjižic">
      Uporaba enote za končno obdelavo knjižic
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_sl" title="Uporaba prenosnega mehanizma za papir z možnostjo pregibanja">
      Uporaba prenosnega mehanizma za papir z možnostjo pregibanja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sl" title="Vzdrževanje tiskalnika">
     Vzdrževanje tiskalnika
    </a>
   </p>
   <div id="divd0e30928">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_sl" title="Preverjanje stanja delov in potro&scaron;nega materiala">
      Preverjanje stanja delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_sl" title="Konfiguracija obvestil o stanju potro&scaron;nega materiala">
      Konfiguracija obvestil o stanju potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_sl" title="Nastavitev e-po&scaron;tnih opozoril">
      Nastavitev e-po&scaron;tnih opozoril
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_sl" title="Ustvarjanje poročil in dnevnikov">
      Ustvarjanje poročil in dnevnikov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_sl" title="Naročanje delov in potro&scaron;nega materiala">
      Naročanje delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31783" title="Zamenjava delov in potro&scaron;nega materiala">
      Zamenjava delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32407" title="Či&scaron;čenje delov tiskalnika">
      Či&scaron;čenje delov tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32571" title="Varčevanje z energijo in papirjem">
      Varčevanje z energijo in papirjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_sl" title="Premikanje tiskalnika na drugo mesto">
      Premikanje tiskalnika na drugo mesto
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sl" title="Odpravljanje težav">
     Odpravljanje težav
    </a>
   </p>
   <div id="divd0e32709">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_sl" title="Težave s kakovostjo tiskanja">
      Težave s kakovostjo tiskanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_sl" title="Kode napak tiskalnika">
      Kode napak tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sl" title="Težave pri tiskanju">
      Težave pri tiskanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_sl" title="Tiskalnik se ne odziva">
      Tiskalnik se ne odziva
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_sl" title="Bliskovnega pogona ni mogoče prebrati">
      Bliskovnega pogona ni mogoče prebrati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_sl" title="Omogočanje vrat USB">
      Omogočanje vrat USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_sl" title="Odpravljanje zastojev">
      Odpravljanje zastojev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36133" title="Težave z omrežno povezavo">
      Težave z omrežno povezavo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36226" title="Težave z možnostmi strojne opreme">
      Težave z možnostmi strojne opreme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399" title="Težave s potro&scaron;nim materialom">
      Težave s potro&scaron;nim materialom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36547" title="Težave pri podajanju papirja">
      Težave pri podajanju papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36741" title="Težave s po&scaron;iljanjem e-po&scaron;te">
      Težave s po&scaron;iljanjem e-po&scaron;te
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36796" title="Težave pri faksiranju">
      Težave pri faksiranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37118" title="Težave pri optičnem branju">
      Težave pri optičnem branju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37536" title="Težave s kakovostjo barv">
      Težave s kakovostjo barv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sl" title="Vzpostavitev stika s podporo strankam">
      Vzpostavitev stika s podporo strankam
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_sl" title="Recikliranje in odlaganje">
     Recikliranje in odlaganje
    </a>
   </p>
   <div id="divd0e37762">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_sl" title="Recikliranje Lexmarkovih izdelkov">
      Recikliranje Lexmarkovih izdelkov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sl" title="Recikliranje Lexmarkove embalaže">
      Recikliranje Lexmarkove embalaže
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sl" title="Obvestila">
     Obvestila
    </a>
   </p>
   <div id="divd0e37798">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37801" title="Podatki o izdelku">
      Podatki o izdelku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37818" title="Obvestilo o izdaji">
      Obvestilo o izdaji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sl" title="Blagovne znamke">
      Blagovne znamke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sl" title="Obvestila o licenciranju">
      Obvestila o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sl" title="Zvočne emisije">
      Zvočne emisije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sl" title="Direktiva o odpadni električni in elektronski opremi (OEEO)">
      Direktiva o odpadni električni in elektronski opremi (OEEO)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37924" title="Litij-ionska baterija za polnjenje">
      Litij-ionska baterija za polnjenje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sl" title="Uredba (EU) 2023/1542">
      Uredba (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37962" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sl" title="Odlaganje izdelka">
      Odlaganje izdelka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sl" title="Vračanje Lexmarkovih kartu&scaron; za ponovno uporabo ali recikliranje">
      Vračanje Lexmarkovih kartu&scaron; za ponovno uporabo ali recikliranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sl" title="Obvestilo o občutljivosti na statično elektriko">
      Obvestilo o občutljivosti na statično elektriko
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sl" title="Podatki o temperaturi">
      Podatki o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sl" title="Obvestilo o laserskem tiskalniku">
      Obvestilo o laserskem tiskalniku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sl" title="Poraba energije">
      Poraba energije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38223" title="Regulativna obvestila za brezžične izdelke">
      Regulativna obvestila za brezžične izdelke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sl" title="Obvestilo o modularnih komponentah">
      Obvestilo o modularnih komponentah
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sl" title="Izpostavljenost radiofrekvenčnemu sevanju">
      Izpostavljenost radiofrekvenčnemu sevanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38248" title="Skladnost z direktivami Evropske skupnosti (ES)">
      Skladnost z direktivami Evropske skupnosti (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sl" title="Skladnost z direktivami Evropske skupnosti (ES)">
      Skladnost z direktivami Evropske skupnosti (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sl" title="Obvestilo o radijskih motnjah">
      Obvestilo o radijskih motnjah
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue